import { useCallback, useMemo, useState } from 'react';
import { useEffectOnceWhen, useWindowEventListener } from 'rooks';

/**
 * Provides standard state for credit card form fields.
 *
 * @return
 * Returns both the current values of fields under their respective property
 * names as well as setters for those fields.
 */
const useCreditCardFieldsState = () => {
  const [cardNumber, onCardNumberChange] = useState('');
  const [expirationMonth, onExpirationMonthChange] = useState<number>(null);
  const [expirationYear, onExpirationYearChange] = useState<number>(null);
  const [nameOnCard, onNameOnCardChange] = useState('');
  const [verificationCode, onVerificationCodeChange] = useState('');

  const fillInTestData = useCallback(() => {
    // cardNumber: '4444444444444448', //Is a generic test card number
    // cardNumber: '5123450000000008', // Is a chase 3DS test card number 33DS2 - Challenge (Method URL provided)
    // cardNumber: '4440000009900010', //Is a chase 3DS test card number 3DS2 - Challenge (No Method URL)
    // cardNumber: '5123456789012346', //Is a chase 3DS test card number 3DS2 - Frictionless (Method URL provided)
    // cardNumber: '5555555555000018', //Is a chase 3DS test card number 3DS2 - Frictionless (No Method URL)
    onCardNumberChange('4000 0000 0000 0002'); // this is a paynamics 3DS test info
    onExpirationYearChange(new Date().getUTCFullYear() + 5); // this is a paynamics 3DS test info
    onExpirationMonthChange(1); // this is a paynamics 3DS test info
    onNameOnCardChange('Test! Tést! Do Not Ship!');
    onVerificationCodeChange('345'); // this is a paynamics 3DS test info
  }, [
    onCardNumberChange,
    onExpirationMonthChange,
    onExpirationYearChange,
    onNameOnCardChange,
    onVerificationCodeChange,
  ]);

  useEffectOnceWhen(() => {
    if (window.location.toString().includes('?test') || window.location.toString().includes('&test')) {
      fillInTestData();
    }
  });

  useWindowEventListener('relivTestModeTestAutoFillInputValuesStart', fillInTestData);

  return useMemo(
    () => ({
      cardNumber,
      expirationMonth,
      expirationYear,
      nameOnCard,
      onCardNumberChange,
      onExpirationMonthChange,
      onExpirationYearChange,
      onNameOnCardChange,
      onVerificationCodeChange,
      verificationCode,
    }),
    [cardNumber, expirationMonth, expirationYear, nameOnCard, verificationCode]
  );
};

export default useCreditCardFieldsState;
